// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dq7HQ","tabsBox":"styles_tabsBox__xfwrY","createButton":"styles_createButton__3R_Mz"};